import { gql } from "@apollo/client";

export const COLLEGE_CERTIFICATE_FIELDS = gql`
  fragment CollegeCertificateFields on CollegeCertificate {
    id
    from
    to
    college {
      id
      name
      title
      status
      category
      logo2 {
        id
        title
        filename
        filesize
        filetype
        url
      }
      parentGroups {
        id
        name
        title
        logo2 {
          id
          title
          filename
          filesize
          filetype
          url
        }
      }
    }
    author {
      id
      name
      type
    }
    done
    created_at
    updated_at
    uid {
      id
      code
      created_at
    }
  }
`;

export const GET_COLLEGE_CERTIFICATE = gql`
  query CollegeCertificate($id: ID!) {
    certCollegeCertificate(id: $id) {
      ...CollegeCertificateFields
    }
  }
  ${COLLEGE_CERTIFICATE_FIELDS}
`;

export const GET_COLLEGE_CERTIFICATES = gql`
  query CollegeCertificates(
    $search: String
    $page: Int
    $limit: Int
    $orderBy: [GetCollegeCertificatesOrderByClause]
  ) {
    certCollegeCertificates(
      search: $search
      page: $page
      limit: $limit
      orderBy: $orderBy
    ) {
      paginatorInfo {
        total
        currentPage
        hasMorePages
      }
      data {
        ...CollegeCertificateFields
      }
    }
  }
  ${COLLEGE_CERTIFICATE_FIELDS}
`;
